// PATH: src/components/catalog/useDialogState.ts
import * as React from "react";

/**
 * Dialogue ouvert + ses données. À la fermeture, les données restent le temps
 * de l'animation (pas de titre qui saute de « Modifier » à « Nouveau »).
 */
export const useDialogState = <T extends { type: string }>() => {
  const [state, setState] = React.useState<T | null>(null);
  const [open, setOpen] = React.useState(false);
  return {
    state,
    show: React.useCallback((d: T) => {
      setState(d);
      setOpen(true);
    }, []),
    close: React.useCallback(() => setOpen(false), []),
    isOpen: (type: T["type"]) => open && state?.type === type,
  };
};
